module.exports = __webpack_public_path__ + "static/img/case3.afb97302.jpg";